import { render, staticRenderFns } from "./MapMiscInfo.vue?vue&type=template&id=ddee85de&scoped=true"
import script from "./MapMiscInfo.vue?vue&type=script&lang=ts"
export * from "./MapMiscInfo.vue?vue&type=script&lang=ts"
import style0 from "./MapMiscInfo.vue?vue&type=style&index=0&id=ddee85de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee85de",
  null
  
)

export default component.exports